
export const CARD_PROCESSING_PRICE_PROGRAM = Object.freeze({
    None: 0,
    NonCashAdjustment: 1,
    Surcharge: 2
});